import React from 'react';
import { IonCard, IonIcon, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonBadge } from '@ionic/react';
import useNavigation from '../hooks/useNavigation';
import { personOutline, call, calendarOutline, businessOutline, locationOutline, chatbubbleOutline } from 'ionicons/icons';
import './LeadCard.css';
import { makeCall } from '../hooks/common';


interface IProps {
    lead: any;
}

const LeadCard: React.FC<IProps> = (props) => {
    const navigateTo = useNavigation();

    return (
        <>
            <IonCard onClick={() => navigateTo('/tabs/lead', { leadId: props.lead.id })} style={{ margin: '8px', borderRadius: '12px' }}>
                {/* Header with Contact Name */}
                <IonItem style={{ '--background': 'transparent', '--border-color': 'transparent' }}>
                    <IonLabel>
                        <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: '0' }}>
                            {props.lead.contactName}
                        </h2>
                    </IonLabel>
                    {props.lead.status && (
                        <IonBadge 
                            color={props.lead.status === 'open' ? 'warning' : props.lead.status === 'closed' ? 'success' : 'primary'}
                            style={{ fontSize: '12px' }}
                        >
                            {props.lead.status}
                        </IonBadge>
                    )}
                </IonItem>

                {/* Main Content Grid */}
                <IonGrid style={{ padding: '0 16px 16px 16px' }}>
                    <IonRow>
                        {/* Left Column - Contact Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Phone Number */}
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                                <IonIcon icon={call} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                <span 
                                    style={{ fontSize: '14px', cursor: 'pointer', color: '#3880ff' }}
                                    onClick={e => makeCall(e, props.lead.contactPhoneNumber)}
                                >
                                    {props.lead.contactPhoneNumber}
                                </span>
                            </div>

                            {/* Location */}
                            {props.lead.location && (
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                                    <IonIcon icon={locationOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                    <span style={{ fontSize: '14px', color: '#666' }}>
                                        {props.lead.location}
                                    </span>
                                </div>
                            )}

                            {/* Serviced By */}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <IonIcon icon={businessOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                <span style={{ fontSize: '14px' }}>
                                    {props.lead.servicer?.name || props.lead.servicedBy || 'N/A'}
                                </span>
                            </div>
                        </IonCol>

                        {/* Right Column - Dates & Comments */}
                        <IonCol size="12" sizeMd="6">
                            {/* Follow-up Date */}
                            {props.lead.followUpDate && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px', marginBottom: '12px' }}>
                                    <IonIcon icon={calendarOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                        Follow-up: {new Intl.DateTimeFormat('en-GB', {
                                            month: 'short',
                                            day: '2-digit',
                                            year: 'numeric',
                                        }).format(new Date(props.lead.followUpDate))}
                                    </span>
                                </div>
                            )}

                            {/* Comments */}
                            {props.lead.comment && (
                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '12px' }}>
                                    <IonIcon icon={chatbubbleOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666', marginTop: '2px' }} />
                                    <span style={{ fontSize: '12px', color: '#666', lineHeight: '1.4' }}>
                                        {props.lead.comment}
                                    </span>
                                </div>
                            )}

                            {/* Created Date - Last line, right aligned */}
                            {props.lead.created_date && (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                    <IonIcon icon={calendarOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                        {new Intl.DateTimeFormat('en-GB', {
                                            month: 'short',
                                            day: '2-digit',
                                            year: 'numeric',
                                        }).format(new Date(props.lead.created_date))}
                                    </span>
                                </div>
                            )}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonCard>
        </>
    );
};

export default LeadCard;
